import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import ButtonMain from "../../../../../../common/components/button/ButtonMain";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
// config,utils
import { ROUTE_PATH } from "../../../../../../config/CONSTANTS";
import urls from "../../../../../../api/project/ApiUrls";
import fireAuth from "../../../../../../api/firebase/auth/utils";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const NotLogIn = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const isLoggedIn = fireAuth.isLoggedIn(user);

  const handleLoginBtnClick = () => {
    navigate(handleLocaleRoute(ROUTE_PATH.LogIn));
  };

  return (
    <Box>
      <Box mb={2}>
        <Typography textAlign="left" variant="body1">
          {intl.formatMessage({
            id: "sna.sidebar.grouptool.not.login",
            defaultMessage: "請登入以獲得更多功能",
          })}
        </Typography>
      </Box>
      <ButtonMain
        buttonProps={{
          text: intl.formatMessage({
            id: "sna.sidebar.grouptool.login",
            defaultMessage: "登入",
          }),
          fullWidth: true,
          onClick: handleLoginBtnClick,
        }}
      />
    </Box>
  );
};

NotLogIn.propTypes = {};

NotLogIn.defaultProps = {};

export default NotLogIn;
